import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';

import { BetslipType } from '../../../core/betslip-type';
import BetslipComboBetActions from '../../combo-bet/actions';
import BetslipSingleBetActions from '../../single-bet/actions';
import BetslipSystemBetActions from '../../system-bet/actions';
import { BetslipTeaserActions } from '../../teaser-bet/actions';
import BetslipPickActions from '../actions';

@Injectable()
export default class PickDigitalEffects {
    constructor(private actions$: Actions) {}

    handleTogglePickForSystemType$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.togglePickForType),
            filter((action) => action.betslipType === BetslipType.System),
            map((action) => BetslipSystemBetActions.toggleSystemBetPick({ pickId: action.pickId })),
        );
    });

    handleTogglePickForComboType$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.togglePickForType),
            filter((action) => action.betslipType === BetslipType.Combo),
            map((action) => BetslipComboBetActions.toggleComboBetPick({ pickId: action.pickId })),
        );
    });

    handleTogglePickForSingleType$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.togglePickForType),
            filter((action) => action.betslipType === BetslipType.Single),
            map((action) => BetslipSingleBetActions.toggleSingleBetPick({ pickId: action.pickId })),
        );
    });

    handleTogglePickForTeaserType$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.togglePickForType),
            filter((action) => action.betslipType === BetslipType.Teaser),
            map((action) => BetslipTeaserActions.togglePick({ pickId: action.pickId.toString() })),
        );
    });
}
